import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'UIComponents/elements/headings';
import UIHelpLink from 'UIComponents/tooltip/UIHelpLink';
import WalmartFormSubmissionFilterEvaluationData from 'flow-doctor-lib/components/filters/WalmartFormSubmissionFilterEvaluationData';
import WalmartFilterPropertyEvaluationData from 'flow-doctor-lib/components/filters/WalmartPropertyFilterEvaluationData';
import usageTracker from 'flow-doctor-lib/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const VALID_EVAL_TYPES = ['PropertyValue', 'FormSubmission'];
const WalmartFilterEvaluationDataPopover = ({
  evaluationData,
  objectTypeId
}) => {
  if (evaluationData.length === 0 || !VALID_EVAL_TYPES.includes(evaluationData[0].dataType)) {
    return null;
  }
  const evalData = evaluationData[0];
  const popoverBody = (() => {
    switch (evalData.dataType) {
      case 'PropertyValue':
        return /*#__PURE__*/_jsx(WalmartFilterPropertyEvaluationData, {
          evalData: evalData,
          objectTypeId: objectTypeId
        });
      case 'FormSubmission':
        return /*#__PURE__*/_jsx(WalmartFormSubmissionFilterEvaluationData, {
          evalData: evalData
        });
      default:
        return null;
    }
  })();
  return /*#__PURE__*/_jsx(UIHelpLink, {
    placement: "left",
    showCloseButton: true,
    onClick: () => usageTracker.track('pageAction', {
      actionType: 'CLICK_VIEW_EVALUATION'
    }),
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.popover.title"
        })
      }),
      body: popoverBody
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.filterEvals.viewMoreDetails"
    })
  });
};
export default WalmartFilterEvaluationDataPopover;